import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Navbar } from '../../../../shared/components/navbar/navbar';
import { DashboardOperations } from "../dashboard-operations/dashboard-operations";
import { DashboardFinancial } from "../dashboard-financial/dashboard-financial";
import { DashboardPendingDeposits } from "../dashboard-pending-deposits/dashboard-pending-deposits";
import { DashboardSupportRisk } from "../dashboard-support-risk/dashboard-support-risk";
import { DashboardDepositAvgChart } from "../dashboard-deposit-avg-chart/dashboard-deposit-avg-chart";
import { DashboardFtdAvgChart } from "../dashboard-ftd-avg-chart/dashboard-ftd-avg-chart";
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import dayjs from 'dayjs';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'app-dashboard',
  imports: [
    Navbar,
    DashboardOperations,
    DashboardFinancial,
    DashboardPendingDeposits,
    DashboardSupportRisk,
    DashboardDepositAvgChart,
    DashboardFtdAvgChart,
    ReactiveFormsModule,
    DatePickerModule
],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Dashboard {
  private readonly _fb: FormBuilder = inject(FormBuilder);
  public periodFilter: FormGroup = this._fb.group({
    date_range: [
      [
        dayjs().startOf('month').toDate(),
        dayjs().toDate()
      ]
    ]
  });

  get startDate(): Date {
    return this.periodFilter.get('date_range')?.value[0];
  }

  get endDate(): Date {
    return this.periodFilter.get('date_range')?.value[1];
  }
}
